import { Box, Chip, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { CustomSelect, useStyles } from './styles';
import CheckIcon from '@mui/icons-material/Check';

interface SelectProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  name: string;
  options: { value: string; label: string }[];
  disabled?: boolean;
  multiple?: boolean;
  error?: string;
}

function Select<TFieldValues extends FieldValues = FieldValues>({ control, name, options, disabled, multiple, error }: SelectProps<TFieldValues>) {
  const classes = useStyles();

  return (
    <Controller
      render={({ field }) => {
        let value;
        if (multiple) {
          value = Array.isArray(field.value) ? field.value.filter((val: string) => val !== '') : [];
        } else {
          value = field.value;
        }
        return (
          <Box sx={{ position: 'relative', width: '100%' }}>
            <CustomSelect
              id={name}
              variant="outlined"
              error={!!error}
              fullWidth
              margin="dense"
              onChange={(e) => {
                field.onChange(e);
              }}
              value={value}
              disabled={disabled}
              multiple={multiple}
              renderValue={(selected) => (
                <div>
                  {Array.isArray(selected)
                    ? selected.map((value) => <Chip key={value} label={options.find((option) => option.value === value)?.label} />)
                    : options.find((option) => option.value === selected)?.label}
                </div>
              )}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: '300px',
                  },
                },
              }}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Box className={classes.Option}>
                    <Typography fontSize={14} fontWeight={500} lineHeight={'24px'} color={'var(--Gray-900, #101828)'}>
                      {option.label}
                    </Typography>
                    {multiple && field.value && field.value.includes(option.value) && <CheckIcon width={20} height={20} style={{ color: 'rgba(48, 137, 60, 1)' }} />}
                  </Box>
                </MenuItem>
              ))}
            </CustomSelect>
          </Box>
        );
      }}
      name={name as Path<TFieldValues>}
      control={control}
    />
  );
}

export default Select;
